module.exports = new __parcel__URL__("octopus.2c0d1056.svg").toString();